import React from 'react';
import { Bold, Italic, Underline } from 'lucide-react';

const TextStyleButtons = ({ styles, onChange }) => {
  const toggleStyle = (style) => {
    onChange({ ...styles, [style]: !styles[style] });
  };

  return (
    <div className="flex gap-1 mt-1">
      <button
        type="button"
        onClick={() => toggleStyle('bold')}
        className={`p-1.5 rounded transition-all duration-200 ${
          styles.bold
            ? 'bg-blue-500 text-white shadow-sm'
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
        }`}
        title="Negrito"
      >
        <Bold className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => toggleStyle('italic')}
        className={`p-1.5 rounded transition-all duration-200 ${
          styles.italic
            ? 'bg-blue-500 text-white shadow-sm'
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
        }`}
        title="Itálico"
      >
        <Italic className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => toggleStyle('underline')}
        className={`p-1.5 rounded transition-all duration-200 ${
          styles.underline
            ? 'bg-blue-500 text-white shadow-sm'
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
        }`}
        title="Sublinhado"
      >
        <Underline className="w-4 h-4" />
      </button>
    </div>
  );
};

export default TextStyleButtons;
